export const formatDate = (date: string | undefined): string =>
  date
    ? new Date(parseInt(date)).toLocaleDateString('en-us', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
    : '';

export const formatDateMetrics = (date: string | undefined): string =>
  date
    ? new Date(date).toLocaleDateString('en-us', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      })
    : 'N/A';
